import { DocType } from 'definitions/DocType';
import { useEffect, useState } from 'react';

import { getDocTypeDropDownStr } from 'definitions/DocTypeUtil';
import { QrDocType } from 'definitions/QrDocType';
import { SiteLanguageType } from 'definitions/SiteLanguageType';
import { docwriteutil } from 'docwrite/community/common/docwriteutil';
import { useLoginInfo, useLoginUtil } from 'hooks/useLoginInfo';
import styled from 'styled-components';
import { loginutil } from 'util/loginutil';
import { roleutil } from 'util/roleutil';

type Props = {
  docType: string;
  setDocType: (docType: string) => void;
  readonly?: boolean;
  readonlySubType?: boolean;
  siteLang: string;
};

const i18all = {
  main_qna: 'I18N_MAIN_QNA',
  main_tech_blog: 'I18N_MAIN_TECH_BLOG',
  main_info_share: 'I18N_MAIN_INFO_SHARE',
  main_sample_store: 'I18N_MAIN_SAMPLE_STORE',
  main_doc: 'I18N_MAIN_DOC',
  main_rnd: 'I18N_MAIN_RND',
  main_partner: 'I18N_LS_PARTNER',
  main_qr: 'I18N_QR_MANUAL',
};
type MainType =
  | 'main_qna'
  | 'main_tech_blog'
  | 'main_info_share'
  | 'main_sample_store'
  | 'main_doc'
  | 'main_rnd'
  | 'main_partner'
  | 'main_qr';

export const downloadtypes = [
  DocType.MANUAL,
  DocType.CATALOG,
  DocType.CERTIFICATION,
  DocType.CAD_DATA,
  DocType.DATASHEET,
  DocType.SOFTWARE,
  DocType.OS,
  DocType.EDUCATION_NOTE,
  DocType.EDUCATION_VIDEO,
  DocType.EDUCATION_INTERNAL,
  DocType.SW_SERVICE,
  DocType.TROUBLE_SHOOTING,
  DocType.MARKETING_MATERIAL,
];

export const sampletypes = [DocType.SAMPLE, DocType.USER_SAMPLE];
export const rndTypes = [DocType.RND_NOTI, DocType.RND_QNA_Q, DocType.RND_TALK];

export const DropDownCmmntyDocType = (props: Props) => {
  const loginInfo = useLoginInfo();
  const loginUtil = useLoginUtil();

  const getMainTypes = () => {
    const base = ['main_doc', 'main_qna', 'main_tech_blog', 'main_info_share', 'main_sample_store', 'main_partner'];
    const base_us = ['main_doc', 'main_tech_blog', 'main_info_share', 'main_sample_store', 'main_partner'];

    if ([SiteLanguageType.KO_KR].includes(props.siteLang)) {
      if (roleutil.hasRole('RND', loginUtil.info.userRoles)) {
        base.push('main_rnd');
      }
      if (loginutil.isQrAdmin(loginInfo)) {
        base.push('main_qr');
      }
      return base;
      //return ["main_qna", "main_tech_blog", "main_info_share", "main_sample_store"];
    } else if ([SiteLanguageType.EN].includes(props.siteLang)) {
      if (loginutil.isQrAdmin(loginInfo)) {
        base.push('main_qr');
      }
      return base;
    } else if ([SiteLanguageType.EN_US].includes(props.siteLang)) {
      if (loginutil.isQrAdmin(loginInfo)) {
        base_us.push('main_qr');
      }
      return base_us;
    }
  };
  const [subtypes, setSubtypes] = useState([]);
  const [maintype, setMaintype] = useState('main_qna' as MainType);
  const [maintypes, setMaintypes] = useState(getMainTypes() as Array<string>);
  const [subtype, setSubtype] = useState(''); // 두 번째 버튼 값
  const [showThirdButton, setShowThirdButton] = useState(false); // 3번째 버튼 상태
  const [thirdButtonOptions, setThirdButtonOptions] = useState([]);
  const [thirdType, setThirdType] = useState(''); // 세 번째 버튼 값

  useEffect(() => {
    setMaintypes(getMainTypes());
    if ([SiteLanguageType.EN_US].includes(props.siteLang)) {
      const t = props.docType;
      if (t === DocType.QNA_A || t === DocType.QNA_Q) {
        props.setDocType(DocType.APPLICATION_NOTE);
        //props.setDocType(DocType.TECH_GENERAL);
        return;
      }
    }
  }, [props.siteLang]);

  useEffect(() => {
    const t = props.docType;

    if (t === DocType.QNA_A || t === DocType.QNA_Q) {
      setMaintype('main_qna');
      setSubtype('');
      setSubtypes([]);
    } else if (blogtypes.includes(t)) {
      setMaintype('main_tech_blog');
      setSubtypes(blogtypes);
      setSubtype(t);
    } else if (infotypes.includes(t)) {
      setMaintype('main_info_share');
      setSubtypes(infotypes);
      setSubtype(t);
    } else if (downloadtypes.includes(t)) {
      setMaintype('main_doc');
      setSubtypes(downloadtypes);
      setSubtype(t);
    } else if (sampletypes.includes(t)) {
      setMaintype('main_sample_store');
      setSubtypes(sampletypes);
      setSubtype(t);
    } else if (roleutil.hasRole('RND', loginUtil.info.userRoles) && rndTypesAdminMage.includes(t)) {
      setMaintype('main_rnd');
      setSubtypes(rndTypesAdminMage);
      setSubtype(t);
    } else if (partnerEmpTypes.includes(t)) {
      roleutil.hasPartnerChecks(loginInfo.userId, props.siteLang).then((res) => {
        //파트너계정인 경우 notice+qna
        if (res === true) {
          setMaintype('main_partner');
          setSubtypes(partnerEmpTypes);
          setSubtype(t);
        } else {
          //아닌경우 notice만 작성 가능
          setMaintype('main_partner');
          setSubtypes(partnerAdmin);
          setSubtype(t);
        }
      });
    } else if (qrManual.includes(t) && thirdType === '') {
      setMaintype('main_qr');
      setSubtypes(qrManual);
      setSubtype(t);
    } else if (parameterTypes.includes(t) && thirdType === '') {
      setMaintype('main_qr');
      setSubtypes(qrManual);
      setSubtype(QrDocType.PARAMETER);
      setShowThirdButton(true);
      setThirdButtonOptions(parameterTypes);
      setThirdType(t);
    } else if (troubleshootingTypes.includes(t) && thirdType === '') {
      setMaintype('main_qr');
      setSubtypes(qrManual);
      setSubtype(QrDocType.TROUBLESHOOTING);
      setShowThirdButton(true);
      setThirdButtonOptions(troubleshootingTypes);
      setThirdType(t);
    }
  }, [props.docType]);

  //const maintypes = gconf.ssqrelease1st ? ["main_qna", "main_tech_blog", "main_info_share"] : ["main_qna", "main_tech_blog", "main_info_share", "main_sample_store"];
  // let maintypes = ["main_qna", "main_tech_blog", "main_info_share", "main_sample_store"];
  // if (ssqutil.islangen()) {
  //   // 일반회원 영어.
  //   maintypes = ["main_tech_blog", "main_info_share", "main_sample_store"];
  // }
  const blogtypes = [
    DocType.APPLICATION_NOTE,
    DocType.TECHNICAL_GUIDE,
    DocType.TROUBLE_SHOOTING_KNW,
    // DocType.TECH_GENERAL, // 2026.09.18 일반 포스트 제거
  ];
  //const infotypes = [DocType.TIP, DocType.DOC_NOTI, DocType.DOC_EVT, DocType.JOB_OFFER, DocType.JOB_SEARCH];
  //const infotypes = [DocType.TIP, DocType.DOC_NOTI, DocType.DOC_EVT];
  const infotypes = [DocType.DOC_NOTI, DocType.DOC_EVT];
  const rndTypesAdminMage = [DocType.RND_NOTI, DocType.RND_QNA_Q, DocType.RND_TALK];
  const partnerEmpTypes = [DocType.PARTNER_NOTI, DocType.PARTNER_QNA_Q];
  const partnerAdmin = [DocType.PARTNER_NOTI];

  const qrManual = [
    QrDocType.WIRING,
    QrDocType.PARAMETER,
    QrDocType.SPECIFICATIONS,
    QrDocType.OPTION_LIST,
    QrDocType.OPERATION_MANUAL,
    QrDocType.TROUBLESHOOTING,
    QrDocType.QR_EDUCATION_VIDEO,
    QrDocType.MANUAL_DOWNLOAD,
    // DocType.QUICK_GUIDE,
  ];
  const parameterTypes = [
    QrDocType.KEYPAD_COMPOSITION,
    QrDocType.PARAMETER_GROUP_COMPOSITION,
    QrDocType.PARAMETER_SETTING,
    QrDocType.KEYPAD_SIMULATION,
  ];
  const troubleshootingTypes = [
    QrDocType.FAULT_TRIPS_OCCURS,
    QrDocType.AFTER_A_TEST_RUN,
    QrDocType.MAINTENANCE,
    QrDocType.FAULT_TRIPS,
    QrDocType.OTHER_FAULTS,
    QrDocType.TRIP,
    QrDocType.TRIPS_AND_WARNING,
  ];

  const handleCmd = (e, cmd, param?) => {
    //console.log("cmd ", cmd, " param ", param, maintype, subtype);
    if (cmd === 'main-change') {
      console.log('main-change');
      setShowThirdButton(false);
      setMaintype(param);

      if (param === 'main_tech_blog') {
        props.setDocType(blogtypes[0]);
      } else if (param === 'main_sample_store') {
        props.setDocType(sampletypes[0]);
      } else if (param === 'main_info_share') {
        props.setDocType(infotypes[0]);
      } else if (param === 'main_doc') {
        props.setDocType(downloadtypes[0]);
      } else if (param === 'main_qna') {
        props.setDocType(DocType.QNA_Q);
      } else if (roleutil.hasRole('RND', loginUtil.info.userRoles) && param === 'main_rnd') {
        props.setDocType(rndTypesAdminMage[0]);
      } else if (param === 'main_partner') {
        roleutil.hasPartnerChecks(loginInfo.userId, props.siteLang).then((res) => {
          if (res === true) {
            props.setDocType(partnerEmpTypes[0]);
          } else {
            props.setDocType(partnerAdmin[0]);
          }
        });
      } else if (param === 'main_qr') {
        props.setDocType(QrDocType.WIRING);
        setMaintype('main_qr');
        setSubtypes(qrManual);
      } else {
        setSubtypes([]);
        setSubtype('');
      }
    } else if (cmd === 'sub-change') {
      if (param === QrDocType.PARAMETER || param === QrDocType.TROUBLESHOOTING) {
        setShowThirdButton(true);

        if (param === QrDocType.PARAMETER) {
          setThirdButtonOptions(parameterTypes);
          setThirdType(parameterTypes[0]);
          setSubtype(param);
          props.setDocType(parameterTypes[0]);
        } else if (param === QrDocType.TROUBLESHOOTING) {
          setThirdButtonOptions(troubleshootingTypes);
          setThirdType(troubleshootingTypes[0]);
          setSubtype(param);
          props.setDocType(troubleshootingTypes[0]);
        }
      } else {
        setShowThirdButton(false);
        setSubtype(param);
        props.setDocType(param);
      }
    } else if (cmd === 'third-change') {
      setThirdType(param);
      props.setDocType(param);
    } else {
      console.error('unknown cmd ', cmd, ' param ', param);
    }
  };
  const trans = docwriteutil.getadmintrans;
  return (
    <Container>
      <select
        className={'select-sm'}
        aria-label={'select-technical-doctype'}
        disabled={props.readonly || false}
        onChange={(e) => {
          if (props.readonly) return;
          handleCmd(e, 'main-change', e.target.value);
        }}
        value={maintype}>
        {maintypes.map((docType) => (
          <option key={docType} value={docType}>
            {trans(i18all[docType])}
          </option>
        ))}
      </select>
      {subtypes.length > 0 ? (
        <>
          <div className='w-2' />
          <select
            className={'select-sm'}
            aria-label={'select-technical-doctype'}
            disabled={props.readonlySubType || false}
            onChange={(e) => {
              if (props.readonlySubType) return;
              handleCmd(e, 'sub-change', e.target.value);
            }}
            value={subtype}>
            {subtypes.map((docType) => (
              <option key={docType} value={docType}>
                {getDocTypeDropDownStr(docType)}
              </option>
            ))}
          </select>
        </>
      ) : null}
      {/* 3번째 버튼 렌더링 */}
      {showThirdButton ? (
        <>
          <div className='w-2' />
          <select
            className={'select-sm'}
            aria-label={'select-technical-doctype'}
            disabled={props.readonly || false}
            onChange={(e) => {
              if (props.readonly) return;
              handleCmd(e, 'third-change', e.target.value);
            }}
            value={props.docType}>
            {thirdButtonOptions.map((docType) => (
              <option key={docType} value={docType}>
                {getDocTypeDropDownStr(docType)}
              </option>
            ))}
          </select>
        </>
      ) : null}
    </Container>
  );
};

const Container = styled.div`
  display: flex;

  .select-sm {
    width: auto !important;
    //min-width: 12.8rem;
    padding: 0 2.4rem 0 1.2rem !important;
    font-size: 1.2rem;
    font-weight: 500;
  }
`;
